import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { ParentStepper } from "../../../components/ParentStepper";
import { BundleParentStepper } from "../../../components/BundleStepper";
import WarningModal from "../../../modals/WarningModal";

export const ListingModal = ({
  show,
  onHide,
  editlistdata,
  mocko_id,
  fetchFeaturedMockups,
  FeaturedMockups,
}) => {
  const [showWarning, setShowWarning] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);

  const handleClose = () => {
    setShowWarning(true);
  };

  useEffect(() => {
    if (confirmClose) {
      onHide();
      setConfirmClose(false);
      setShowWarning(false);
    }
  }, [confirmClose, onHide]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="stepper-modal"
      centered
    >
      <Modal.Body
        style={{
          padding: "0px",
          height: "95vh",
          overflowY: "auto",
          background: "#FDFAF1",
          borderRadius: "6px",
        }}
      >
        <ParentStepper
          editlistdata={editlistdata}
          onHide={onHide}
          fetchFeaturedMockups={fetchFeaturedMockups}
          mocko_id={mocko_id}
        />
        <WarningModal
          showModal={showWarning}
          modalClose={() => setShowWarning(false)}
          setConfirmClose={() => setConfirmClose(true)}
          text="Do you want to quit? You will lose all your changes."
        />
      </Modal.Body>
    </Modal>
  );
};

export const BundleModal = ({
  show,
  onHide,
  editlistdata,
  mocko_id,
  fetchBundleMockups,
  FeaturedMockups,
}) => {
  const [showWarning, setShowWarning] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);

  const handleClose = () => {
    setShowWarning(true);
  };

  useEffect(() => {
    if (confirmClose) {
      onHide();
      setConfirmClose(false);
      setShowWarning(false);
    }
  }, [confirmClose, onHide]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="stepper-modal"
      centered
    >
      <Modal.Body
        style={{
          padding: "0px",
          height: "95vh",
          overflowY: "auto",
          background: "#FDFAF1",
          borderRadius: "6px",
        }}
      >
        <BundleParentStepper
          editlistdata={editlistdata}
          onHide={onHide}
          fetchBundleMockups={fetchBundleMockups}
          mocko_id={mocko_id}
          FeaturedMockups={FeaturedMockups}
        />
        <WarningModal
          showModal={showWarning}
          modalClose={() => setShowWarning(false)}
          setConfirmClose={() => setConfirmClose(true)}
          text="Do you want to quit? You will lose all your changes."
        />
      </Modal.Body>
    </Modal>
  );
};

